const selectors = {
    el: '.js-story:not(.is-initialized)',
    slide: '.js-story-slide',
    header: '.js-header',
}

const classes = {
    active: 'is-active',
    white: 'is-white',
}

const handleVideoPlayback = (video) => {
    if (video.checkVisibility({
        opacityProperty: true,
    })) {
        video.play();
    } else {
        video.pause();
    }
}

const init = () => {
    const els = document.querySelectorAll(selectors.el);
    const header = document.querySelector(selectors.header);
    const videos = document.querySelectorAll('VIDEO');

    videos.forEach((video, i) => {
        if (i === 0) return;
        handleVideoPlayback(video);
    });

    document.addEventListener('click', () => {
        videos.forEach(video => {
            handleVideoPlayback(video);
        });
    });

    const updateHeader = (activeSlide, el) => {
        if (activeSlide.dataset.navInvert) {
            el.classList.add(classes.white);
            header.classList.add(classes.white);
        } else {
            el.classList.remove(classes.white);
            header.classList.remove(classes.white);
        }
    }

    els.forEach(el => {
        el.classList.add('is-initialized');
        
        const slides = [...el.querySelectorAll(selectors.slide)];
        let i = 0;
        slides[i].classList.add(classes.active);
        updateHeader(slides[i], el);

        el.addEventListener('click', () => {
            slides[i].classList.remove(classes.active);
            i++;
            if (i >= slides.length) i = 0;
            slides[i].classList.add(classes.active);

            updateHeader(slides[i], el);
        });
    });
};

const module = () => {
    init();
    document.addEventListener('domUpdated', init);
};

export default module;